<template>
    <div class="modal-content modal--happy">
        <page-preloader :is-loading="isLoading" mode="wrapper">
            <div class="modal-header border-0 text-ceter">
                <modal-close />
                <div class="modal-title">
                    <h2 class="h3 px-2 pt-4 pb-1">Dołączanie sklepów do sieci</h2>
                </div>
            </div>
            <div class="modal-body p-4 text-primary">
                <h5>Zaznaczone sklepy:</h5>
                <div>
                    <ui-data-table
                        tableName='stores-added-to-join'
                        mobile-striped
                        mobileBreakpoint="lg"
                        :tableData="tableData"
                        td-custom-class='p-2'
                    />
                </div>
                <div>
                    <add-stores-to-network-form @submit="addStoresToNetworkFormSubmit" @cancel="closeModal" :pinError="pinError" />
                </div>
            </div>
        </page-preloader>
    </div>
</template>

<script>
import UiDataTable from '../global/ui/UiDataTable.vue'
import { AddStoresToNetworkForm } from '../userStores'

export default {
    name: 'AddStoresToNetwork',
    components: { UiDataTable, AddStoresToNetworkForm },
    computed: {
        selectedStores() {
            if(!this.$store.getters.getAbleToJoinStores) return []
            return this.$store.getters.getAbleToJoinStores && this.$store.getters.getAbleToJoinStores.filter(store => store.checked)
        },
        tableData() {
            const head = ['Nazwa', 'Adres sklepu']
            const body = this.selectedStores.map(item => {
                return [
                    { text: item.shopName, customClass: 'text-primary' },
                    item.shopAddress,
                    { type: 'hidden', data: { id: item.shopId } }
                ]
            })
            return { head, body }
        }
    },
    data() {
        return{
            pinError: null,
            isLoading: false
        }
    },
    methods: {
        async addStoresToNetworkFormSubmit({ pin, networkId }) {
            try{
                this.isLoading = true
                const response = await this.$store.dispatch('addStoresToNetwork', { pin, networkId })

                if(response.data.data.errors && response.data.data.errors[0]) {
                    const err = response.data.data.errors && response.data.data.errors[0]

                    if(err.field && err.code && err.field === 'pin' && err.code === 'ERR_INVALID_FORMAT') { this.pinError = 'Nieprawidłowy PIN'; throw new Error('WRONG_PIN_ERROR') }
                }

                this.closeModal()
                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Zgłoszenie dołączenia sklepów do sieci zostało przyjęte.'
                })

                await this.$store.dispatch('resetUserStoresState')
                this.$scrollTo(top, 400)
                this.$store.dispatch('storesFetch')
            }catch(err) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd. Spróbuj ponownie później.'
                })
            }finally{
                this.isLoading = false
            }
        },
        closeModal() {
            this.$store.dispatch('toggleModal', false)
        }
    }
}
</script>